import RegulationCreate from './regulation.create';
import RegulationEdit from './regulation.edit';

export default {
  create: RegulationCreate,
  edit: RegulationEdit,
};
